import axiosInstance from "../utils/api";


export const regenerateInvoiceProcessing = async (id, sessionId = null) => {
  const formData = new FormData();
  formData.append("id", id);
  if (sessionId) {
    formData.append("session_id", sessionId);
  }
  
  return axiosInstance.post("/api/v1/regenerate_invoice_processing", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getInvoiceProcessing = async (documentId) => {
  return axiosInstance.get(`/api/v1/invoice_processings/${documentId}`);
};


export const updateInvoiceProcessing = async (id, data) => {
  return axiosInstance.put(`/api/v1/invoice_processings/${id}`, {
    fouray_response: data
  });
};

export const bulkCreateInvoiceProcessings = async (payload) => {
  return axiosInstance.post("/api/v1/invoice_processings/bulk_create", payload);
};

export const getAuditLogs = async (tableName, recordId) => {
  return axiosInstance.get("/api/v1/audit_logs", {
    params: {
      table_name: tableName,
      record_id: recordId,
    },
  });
};
